import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { WalletHistoryResponse } from "@/shared/repository/modules/wallet/repo";
import { SvgAttribute } from "@/shared/constants/constants";
import { ApplicationStatus } from "@/shared/constants/enums";
import { formatCryptoCurrency } from "@/shared/utils/amount-helpers";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    row: {
      type: <PropType<WalletHistoryResponse>>Object,
      required: true,
    },
    isDetails: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    depositWithdrawal: null,
    remove: null,
  },
  data() {
    return {
      depositWithdrawalRepo: this.$projectServices.depositWithdrawalRepo,
    };
  },
  computed: {
    displayedType(): string {
      if (this.row.type === "deposit") {
        return this.$t("Пополнение");
      }
      if (this.row.type === "withdrawal") {
        return this.$t("Вывод");
      }
      if (this.row.type === "exchange") {
        return this.$t("Обмен");
      }
      return this.$t("Неизвестно");
    },

    displayedSvg(): SvgAttribute {
      return SVG;
    },

    displayedAmount(): string {
      return formatCryptoCurrency(+this.row.amount);
    },

    displayedWallet(): string {
      if (this.row.type === "withdrawal") {
        const tag = this.row.tag ? this.row.tag : "";
        return this.row.address + " " + tag + " (" + this.row.chain + ")";
      }
      if (this.row.type === "exchange") {
        return this.row.address;
      }
      return "";
    },

    isConfirmShow(): boolean {
      return (
        this.row.status === ApplicationStatus.pending &&
        this.row.type !== "withdrawal"
      );
    },

    isRemoveShow(): boolean {
      return this.row.status === ApplicationStatus.pending;
    },
  },
  methods: {
    handleRow(): void {
      this.$emit("depositWithdrawal", this.row);
    },
  },
});
